import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Button,
  FormControl,
  Select,
  MenuItem,
  TablePagination,
  Tooltip,
  Input,
} from "@material-ui/core/";
import moment from "moment";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import { useSelector, useDispatch } from "react-redux";
import {
  removeParticularModalData,
  updatePrice,
} from "../../../reduxSlices/selectClassSlice";
import { isObjectEmpty } from "../../../utils/general";
import {
  clearLoginData,
  isLoggedInUpdate,
} from "../../../reduxSlices/loginSlice";
import Backdrop from "../../Backdrop";
import Aux from "../../../hoc/Auxilliary";
import MessageIndicator from "../../SnackBar";
import localizedStrings from "../../../utils/localize";

import { getOptionList } from "../../../reduxSlices/applicationSlice";

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#005598",
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

const useStyles = makeStyles({
  TableControl: {
    display: "flex",
    flexDirection: "column",
  },

  formControl: {
    color: "white",
    fontSize: "0.875rem",
  },
});

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

function PageConatiner(props) {
  const dispatch = useDispatch();
  const classes = useStyles();
  const [error, setError] = useState({
    isError: false,
    message: "",
    showSnackbar: false,
  });
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [termsData, setTerms] = useState("");
  const [schoolsData, setSchoolsData] = useState("");
  const [tableMapData, setTableMapData] = useState([]);
  const [facultyList, setfacultyList] = useState([]);
  const [courselevelData, setcourselevelData] = useState([]);

  const [dptData, setDptData] = useState("");
  const [courseData, setCourseData] = useState("");
  const [facultyData, setfacultyData] = useState("");
  const [campuses, setCampusData] = useState("");
  const modalData = useSelector((state) => state.selectClassData.modalData);
  const selectClassData = useSelector(
    (state) => state.selectClassData.selectClassData,
  );
  const price = useSelector((state) => state.selectClassData.price);
  const dataFetchingStatus = useSelector(
    (state) => state.selectClassData.dataFetchingStatus,
  );
  const optionList = useSelector((state) => state.applicationData.optionList);
  const errorMessage = useSelector(
    (state) => state.selectClassData.errorMessage,
  );

  const errorStatusCode = useSelector(
    (state) => state.selectClassData.errorStatusCode,
  );

  //current lagnguage
  const language = useSelector((state) => state.language.language);
  //set the current language to localize string
  localizedStrings.setLanguage(language);
  useEffect(() => {
    localizedStrings.setLanguage(language);
  }, [language]);

  const handleClose = () => {
    let errorCopy = { ...error };
    errorCopy.showSnackbar = false;
    setError(errorCopy);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handelLogout = () => {
    dispatch(clearLoginData());
    window.localStorage.removeItem("x-auth-token");
    window.localStorage.removeItem("x-auth-fullname");
    window.localStorage.removeItem("x-auth-contactId");
    window.localStorage.removeItem("isUserLoggedIn");
    dispatch(isLoggedInUpdate(false));
    // dispatch(clearErrorStatusCode());
    // dispatch(clearErrorMessage());
    // dispatch(clearClassData());
    props.history.push("/login");
  };

  useEffect(() => {
    if (!isObjectEmpty(modalData)) {
      const removeEmptyObjmodalData = modalData?.filter(
        (value) => Object.keys(value).length !== 0,
      );
      setTableMapData(removeEmptyObjmodalData);
    }
    const copyTableMapData = [...modalData];
    var facultyList = [];
    copyTableMapData?.map((element) => {
      if (element.facultyName?.length != 0) {
        element?.facultyName?.map((e) => {
          facultyList.push(e.ses_facultyname);
        });
        setfacultyList(facultyList);
      }
    });
  }, [modalData]);
  const handleChange = async (event) => {
    const copyTableMapData = [...modalData];
    if (event.target.name === "courselevel") {
      setcourselevelData(event.target.value);
      setSchoolsData("");
      setTerms("");
      setDptData("");
      setCourseData("");
      setfacultyData("");
      if (event.target.value?.length === 0) {
        setTableMapData(copyTableMapData);
      } else {
        let copyData = copyTableMapData.filter(
          (element) => element.ses_courselevel === event.target.value,
        );
        setTableMapData(copyData);
      }
    }

    if (event.target.name === "faculty") {
      var eventName = event?.target?.value?.toLowerCase();
      setfacultyData(event.target.value);
      setSchoolsData("");
      setTerms("");
      setDptData("");
      setcourselevelData("");
      setCourseData("");
      if (event.target.value?.length === 0) {
        setTableMapData(copyTableMapData);
      } else {
        var copyDataa = [];
        copyTableMapData?.forEach(async (element) => {
          element?.facultyName?.map(async (fac) => {
            if (
              fac?.ses_facultyname.toLowerCase().includes(eventName) === true
            ) {
              copyDataa.push(element);
            }
            await setTableMapData(copyDataa);
          });
        });
        await setTableMapData(copyDataa);
      }
    }
    if (event.target.name === "term") {
      if (event.target.value?.length === 0) {
        setTableMapData(copyTableMapData);
      } else {
        let copyData = copyTableMapData.filter(
          (element) => element.ses_termname === event.target.value,
        );
        setTableMapData(copyData);
      }

      setTerms(event.target.value);
      setSchoolsData("");
      setDptData("");
      setCourseData("");
      setcourselevelData("");
      setfacultyData("");
    }
    if (event.target.name === "school") {
      if (event.target.value?.length === 0) {
        setTableMapData(copyTableMapData);
      } else {
        let copyData = copyTableMapData.filter(
          (element) => element.ses_schoolname === event.target.value,
        );
        setTableMapData(copyData);
      }
      setTerms("");
      setDptData("");
      setSchoolsData(event.target.value);
      setCourseData("");
      setcourselevelData("");
      setfacultyData("");
    }
    if (event.target.name === "dept") {
      if (event.target.value?.length === 0) {
        setTableMapData(copyTableMapData);
      } else {
        let copyData = copyTableMapData.filter(
          (element) => element.ses_departmentname === event.target.value,
        );
        setTableMapData(copyData);
      }

      setDptData(event.target.value);
      setSchoolsData("");
      setTerms("");
      setCourseData("");
      setcourselevelData("");
      setfacultyData("");
    }
    if (event.target.name === "course") {
      if (event.target.value?.length === 0) {
        setTableMapData(copyTableMapData);
      } else {
        let copyData = copyTableMapData.filter(
          (element) => element.ses_coursename === event.target.value,
        );
        setTableMapData(copyData);
      }
      setSchoolsData("");
      setTerms("");
      setDptData("");
      setcourselevelData("");
      setfacultyData("");
      setCourseData(event.target.value);
    }
  };
  useEffect(() => {
    if (!isObjectEmpty(errorMessage) && errorMessage !== undefined) {
      if (errorStatusCode === 401) {
        let error = {
          isError: false,
          message: "Session Expired",
          showSnackbar: true,
        };
        setError(error);
        setTimeout(() => {
          handelLogout();
        }, 1600);
      } else {
        let error = {
          isError: false,
          message: errorMessage,
          showSnackbar: true,
        };
        setError(error);
      }
    }
  }, [errorMessage, errorStatusCode]);

  const handleDelete = (id) => {
    const copyTableMapData = [...tableMapData];

    dispatch(
      removeParticularModalData(
        copyTableMapData.filter((data) => data.id !== id),
      ),
    );
  };
  const HtmlTooltip = withStyles((theme) => ({
    tooltip: {
      backgroundColor: "#f5f5f9",
      color: "rgba(0, 0, 0, 0.87)",
      maxWidth: 220,
      fontSize: theme.typography.pxToRem(12),
      border: "1px solid #dadde9",
    },
  }))(Tooltip);
  const handleClick = (e) => {
    e.preventDefault();

    props.history.push({
      pathname: "/students/select-class/checkout",
    });
  };
  const removeDuplicateFromObjects = (objectArray, field) => {
    if (objectArray?.length > 0) {
      if (field === "termName")
        return objectArray.filter(
          (v, i, a) =>
            a.findIndex((t) => t.ses_termname === v.ses_termname) === i,
        );
      else if (field === "schoolName")
        return objectArray.filter(
          (v, i, a) =>
            a.findIndex((t) => t.ses_schoolname === v.ses_schoolname) === i,
        );
      else if (field === "dept")
        return objectArray.filter(
          (v, i, a) =>
            a.findIndex(
              (t) => t.ses_departmentname === v.ses_departmentname,
            ) === i,
        );
      else if (field === "course") {
        let newObjectArray = objectArray.filter(
          (value) => Object.keys(value).length !== 0,
        );
        newObjectArray.filter(
          (v, i, a) =>
            a.findIndex((t) => t.ses_coursename === v.ses_coursename) === i,
        );
        return newObjectArray;
      } else if (field === "campus")
        return objectArray.filter(
          (v, i, a) =>
            a.findIndex((t) => t.ses_campusname === v.ses_campusname) === i,
        );
      else if (field === "courselevel") {
        objectArray.filter(
          (v, i, a) =>
            a.findIndex((t) => t.ses_courselevel === v.ses_courselevel) === i,
        );
        return objectArray;
      }
    }
    return [];
  };

  const calcuatePrice = (selectClassData) => {
    let intialPrice = 0;
    selectClassData.forEach((element) => {
      intialPrice += parseInt(element.price);
    });
    dispatch(updatePrice(intialPrice));
  };

  const funcOptionList = (status) => {
    var value;
    if (!isObjectEmpty(optionList) && optionList?.length != 0) {
      optionList?.map((ele) => {
        if (ele.attributevalue === status) {
          value = ele.value;
        }
      });
    }
    return value;
  };
  const funcStartDate = (date) => {
    var firstMeetingValue = "";

    if (
      date != "Invalid date" &&
      date != undefined &&
      date != null &&
      date != ""
    ) {
      firstMeetingValue = moment(date).format("MM/DD/YYYY");
    }
    if (date === "Invalid date") {
      firstMeetingValue = "";
    }

    return firstMeetingValue;
  };

  useEffect(() => {
    let entity = "ses_course";
    let attributename = "ses_courselevel";
    dispatch(getOptionList(entity, attributename));
  }, [dispatch]);

  useEffect(() => {
    if (selectClassData.length > 0) {
      calcuatePrice(selectClassData);
      setTableMapData(selectClassData);
    }
  }, [selectClassData]);

  let tableData = "";
  let termData = "";
  let schoolData = "";
  let deptsData = "";
  let coursesData = "";
  let courseLevels = "";
  let campusData = "";

  if (!isObjectEmpty(modalData)) {
    if (modalData) {
      if (Array.isArray(modalData)) {
        tableData =
          tableMapData?.length > 0
            ? tableMapData
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((element, index) => {
                  return (
                    <StyledTableRow key={index}>
                      <StyledTableCell component="th" scope="row">
                        <HtmlTooltip
                          title={
                            <React.Fragment>
                              <Typography
                                component="body"
                                style={{ fontSize: "0.75rem" }}
                              >
                                {
                                  localizedStrings.students.selectClasses
                                    .modalTable.class
                                }{" "}
                                - {element.ses_class}
                              </Typography>

                              <Typography
                                component="body"
                                style={{ fontSize: "0.75rem" }}
                              >
                                {
                                  localizedStrings.students.selectClasses
                                    .modalTable.department
                                }{" "}
                                - {element.ses_departmentname}
                              </Typography>
                              <Typography
                                component="body"
                                style={{ fontSize: "0.75rem" }}
                              >
                                {
                                  localizedStrings.students.selectClasses
                                    .modalTable.course
                                }{" "}
                                - {element.ses_coursename}
                              </Typography>
                              <Typography
                                component="body"
                                style={{ fontSize: "0.75rem" }}
                              >
                                {
                                  localizedStrings.students.selectClasses
                                    .modalTable.startDate
                                }{" "}
                                - {element.ses_startdate}
                              </Typography>
                              <Typography
                                component="body"
                                style={{ fontSize: "0.75rem" }}
                              >
                                {
                                  localizedStrings.students.selectClasses
                                    .modalTable.endDate
                                }{" "}
                                - {element.ses_enddate}
                              </Typography>
                              <Typography
                                component="body"
                                style={{ fontSize: "0.75rem" }}
                              >
                                {
                                  localizedStrings.students.selectClasses
                                    .modalTable.credits
                                }{" "}
                                -{" "}
                                {element.ses_creditsavailable ===
                                (null || undefined || "")
                                  ? ""
                                  : element.ses_creditsavailable}
                              </Typography>
                              <Typography
                                component="body"
                                style={{ fontSize: "0.75rem" }}
                              >
                                {
                                  localizedStrings.students.selectClasses
                                    .modalTable.rooms
                                }{" "}
                                - {element.ses_roomname}
                              </Typography>
                            </React.Fragment>
                          }
                        >
                          <Button>
                            {element.ses_termname === undefined
                              ? ""
                              : element.ses_termname}{" "}
                          </Button>
                        </HtmlTooltip>
                      </StyledTableCell>
                      <StyledTableCell>
                        {element.ses_schoolname === undefined
                          ? ""
                          : element.ses_schoolname}
                      </StyledTableCell>
                      <StyledTableCell>
                        {element.ses_departmentname === undefined
                          ? ""
                          : element.ses_departmentname}
                      </StyledTableCell>
                      <StyledTableCell>
                        <HtmlTooltip
                          title={
                            <React.Fragment>
                              <Typography
                                component="body"
                                style={{ fontSize: "0.75rem" }}
                              >
                                {
                                  localizedStrings.students.selectClasses
                                    .description
                                }{" "}
                                - {element.ses_longdescription}
                              </Typography>
                            </React.Fragment>
                          }
                        >
                          <Button style={{ textAlign: "left" }}>
                            {element.ses_course === undefined
                              ? ""
                              : ` ${element?.ses_course}- ${element?.ses_classname}`}
                            <br />
                            {element.ses_campusname === undefined
                              ? ""
                              : `${element?.ses_campusname}`}{" "}
                            {element?.ses_campusname && element?.ses_roomname
                              ? "-"
                              : element?.ses_roomname === null &&
                                  element?.ses_campusname === null
                                ? "-"
                                : ""}
                            {element?.ses_roomname === undefined
                              ? ""
                              : `${element?.ses_roomname}`}
                          </Button>
                        </HtmlTooltip>
                      </StyledTableCell>

                      <StyledTableCell>
                        {element.facultyName?.length > 0
                          ? element.facultyName.map((e, index) => (
                              <Typography variant="body2" display="block">
                                {e.ses_facultyname}
                                {e.ses_facultyname !== null &&
                                element.facultyName?.length > 1 &&
                                element.facultyName?.length - index !== 1
                                  ? `,`
                                  : null}
                              </Typography>
                            ))
                          : null}
                      </StyledTableCell>
                      <StyledTableCell>
                        {" "}
                        {funcOptionList(element.ses_courselevel)}
                      </StyledTableCell>
                      <StyledTableCell>
                        {element.ses_creditsavailable
                          ? element.ses_creditsavailable.toFixed(2)
                          : ""}
                      </StyledTableCell>

                      <StyledTableCell>
                        {element?.numberEnrolled &&
                        element?.numberEnrolled != (undefined && null)
                          ? element?.numberEnrolled
                          : 0}
                        /
                        {element?.ses_classcapacity &&
                        element?.ses_classcapacity != (undefined && null)
                          ? element?.ses_classcapacity
                          : 0}
                      </StyledTableCell>
                      <StyledTableCell>
                        {funcStartDate(element.ses_startdate)}
                      </StyledTableCell>
                    </StyledTableRow>
                  );
                })
            : null;

        termData = removeDuplicateFromObjects(modalData, "termName").map(
          (element, index) => (
            <MenuItem
              value={element.ses_termname}
              key={index}
              style={{ fontSize: "0.875rem" }}
            >
              {element.ses_termname}
            </MenuItem>
          ),
        );

        schoolData = removeDuplicateFromObjects(modalData, "schoolName").map(
          (element, index) => (
            <MenuItem
              value={element.ses_schoolname}
              key={index}
              style={{ fontSize: "0.875rem" }}
            >
              {element.ses_schoolname}
            </MenuItem>
          ),
        );

        deptsData = removeDuplicateFromObjects(modalData, "dept").map(
          (element, index) => (
            <MenuItem
              value={element.ses_departmentname}
              key={index}
              style={{ fontSize: "0.875rem" }}
            >
              {element.ses_departmentname}
            </MenuItem>
          ),
        );
        coursesData = removeDuplicateFromObjects(modalData, "course").map(
          (element, index) => (
            <MenuItem
              value={element.ses_coursename}
              key={index}
              style={{ fontSize: "0.875rem" }}
            >
              {` ${element.ses_course}- ${element.ses_coursename}`}
            </MenuItem>
          ),
        );

        courseLevels = removeDuplicateFromObjects(modalData, "courselevel").map(
          (element, index) => (
            <MenuItem
              value={element.ses_courselevel}
              key={index}
              style={{ fontSize: "0.875rem" }}
            >
              {funcOptionList(element.ses_courselevel)}

              {/* {`  ${element.ses_courselevel}`} */}
            </MenuItem>
          ),
        );
        campusData = removeDuplicateFromObjects(modalData, "campus").map(
          (element, index) => (
            <MenuItem
              value={element.ses_campusname}
              key={index}
              style={{ fontSize: "0.875rem" }}
            >
              {`${element.ses_campusname}`}
            </MenuItem>
          ),
        );
      }
    }
  }
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  return (
    <Aux>
      <MessageIndicator
        open={error.showSnackbar}
        message={error.message}
        handleClose={handleClose}
      />
      <Backdrop show={dataFetchingStatus} />
      <TableContainer
        component={Paper}
        style={{ minHeight: "40vh", marginBottom: "10px" }}
      >
        <Table aria-label="customized table">
          <TableHead>
            <TableRow>
              <StyledTableCell className={classes.formRoot}>
                {/* {localizedStrings.students.selectClasses.modalTable.term}
                <br /> */}
                <FormControl className={classes.formControl}>
                  <Select
                    value={termsData}
                    onChange={handleChange}
                    className={classes.formControl}
                    displayEmpty
                    name="term"
                  >
                    <MenuItem value="" style={{ fontSize: "0.875rem" }}>
                      {" "}
                      {
                        localizedStrings.students.selectClasses.modalTable
                          .allTerms
                      }
                    </MenuItem>
                    {termData}
                  </Select>
                </FormControl>
              </StyledTableCell>
              <StyledTableCell>
                {/* {localizedStrings.students.selectClasses.modalTable.schoolname}{" "}
                <br /> */}
                <FormControl className={classes.formControl}>
                  <Select
                    value={schoolsData}
                    onChange={handleChange}
                    className={classes.formControl}
                    displayEmpty
                    name="school"
                  >
                    <MenuItem value="" style={{ fontSize: "0.875rem" }}>
                      {" "}
                      {
                        localizedStrings.students.selectClasses.modalTable
                          .allSchools
                      }
                    </MenuItem>
                    {schoolData}
                  </Select>
                </FormControl>
              </StyledTableCell>
              <StyledTableCell
              // style={{ display: "flex", flexDirection: "column" }}
              >
                {/* {localizedStrings.students.selectClasses.modalTable.department} */}
                <FormControl className={classes.formControl}>
                  <Select
                    value={dptData}
                    onChange={handleChange}
                    className={classes.formControl}
                    displayEmpty
                    name="dept"
                  >
                    <MenuItem value="" style={{ fontSize: "0.875rem" }}>
                      {
                        localizedStrings.students.selectClasses.modalTable
                          .allDepartments
                      }
                    </MenuItem>
                    {deptsData}
                  </Select>
                </FormControl>
              </StyledTableCell>
              <StyledTableCell>
                {/* {localizedStrings.students.selectClasses.modalTable.course} */}
                <FormControl
                  className={classes.formControl}
                  style={{ display: "flex" }}
                >
                  <Select
                    value={courseData}
                    onChange={handleChange}
                    className={classes.formControl}
                    displayEmpty
                    name="course"
                  >
                    <MenuItem value="" style={{ fontSize: "0.875rem" }}>
                      {
                        localizedStrings.students.selectClasses.modalTable
                          .allCourses
                      }
                    </MenuItem>
                    {coursesData}
                  </Select>
                </FormControl>
              </StyledTableCell>
              <StyledTableCell>
                {" "}
                {localizedStrings.students.selectClasses.modalTable.faculty}
                <br />
                <Input
                  // label={
                  //   localizedStrings.students.selectClasses.modalTable.faculty
                  // }
                  value={facultyData}
                  onChange={handleChange}
                  className={classes.formControl}
                  displayEmpty
                  name="faculty"
                />
              </StyledTableCell>
              <StyledTableCell>
                {/* {localizedStrings.students.selectClasses.modalTable.courselevel} */}
                <FormControl
                  className={classes.formControl}
                  style={{ display: "flex" }}
                >
                  <Select
                    value={courselevelData}
                    onChange={handleChange}
                    className={classes.formControl}
                    displayEmpty
                    name="courselevel"
                  >
                    <MenuItem value="" style={{ fontSize: "0.875rem" }}>
                      {
                        localizedStrings.students.selectClasses.modalTable
                          .allcourseLevel
                      }
                    </MenuItem>
                    {courseLevels}
                  </Select>
                </FormControl>
              </StyledTableCell>
              <StyledTableCell>
                {localizedStrings.students.selectClasses.modalTable.credits}
              </StyledTableCell>
              <StyledTableCell>
                {localizedStrings.students.selectClasses.modalTable.enrolled}
              </StyledTableCell>
              <StyledTableCell>
                {localizedStrings.students.selectClasses.modalTable.firstMeet}
              </StyledTableCell>

              {/* <StyledTableCell>{localizedStrings.students.selectClasses.modalTable.actions}</StyledTableCell> */}
            </TableRow>
          </TableHead>
          <TableBody>{tableData}</TableBody>
        </Table>
        <TablePagination
          style={{ textTransform: "capitalize" }}
          rowsPerPageOptions={[5, 10, 25, 100]}
          component="div"
          count={tableMapData?.length > 0 ? tableMapData?.length : 0}
          rowsPerPage={rowsPerPage}
          page={page}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
        />
      </TableContainer>
      {selectClassData.length > 0 && (
        <Typography
          component="div"
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginBottom: "1rem",
            width: "100%",
          }}
        >
          <Typography>
            <Button
              color="primary"
              style={{ textTransform: "capitalize" }}
              disableRipple
            >
              {`${localizedStrings.students.selectClasses.total} $ ${price}`}
            </Button>
          </Typography>
          <Button
            variant="outlined"
            color="primary"
            style={{ textTransform: "capitalize", marginLeft: "0.5rem" }}
            endIcon={<NavigateNextIcon />}
            onClick={handleClick}
          >
            {localizedStrings.students.selectClasses.next}
          </Button>
        </Typography>
      )}
    </Aux>
  );
}

export default withRouter(PageConatiner);
